module.exports = __webpack_public_path__ + "img/plan01_text0202.a2d50723.png";